import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api from "../client"
import { AddressFulltextSearchResponseData } from "../types/address"

const getData = async (search: string | undefined) => {
  try {
    const { data } = await api.get(`/address/fulltext/${search}`)
    return data
  } catch ({ response: { data } }) {
    return data
  }
}

export const useAddressFulltextSearch = (search: string | undefined):
  QueryObserverBaseResult<AddressFulltextSearchResponseData> => {
  const { data, ...props } = useQuery<AddressFulltextSearchResponseData>(
    queryKeys.ADDRESS_FULLTEXT(search),
    () => getData(search),
    { enabled: Boolean(search) }
  )
  return { data, ...props }
}
